module.exports = __webpack_public_path__ + "img/meme_03.73df4d81.jpg";